import { ValidationMessages } from 'common/validation/validation-messages';
import { phoneValidationRule } from '../../../../../../common/validation/phone-number-rule';
import { RuleType } from 'rc-field-form/lib/interface';

export const addEditResidentValidation = {
  firstName: [{ required: true, message: 'First name is required!' }],
  lastName: [{ required: true, message: 'Last name is required!' }],
  type: [{ required: true, message: 'Type is required!' }],
  email: [{ message: ValidationMessages.Email.NotValidMessage, type: 'email' as RuleType }],
  pin: [{ required: true, message: 'Pin is required!' }],
  legacyCode: [{ max: 255, message: 'Legacy Code must be at most 255 characters!' }],
  phone: [{ required: false, message: 'Phone number is required!' }, phoneValidationRule],
  rentStartDate: [{ required: true, message: 'Rent start date is required!' }],
  rentEndDate: [{ required: true, message: 'Rent end date is required!' }],
  relatedTo: [{ required: true, message: 'Parent resident is required!' }],
  vacationStartDate: [{ required: true, message: 'Vacation start date is required!' }],
  vacationEndDate: [{ required: true, message: 'Vacation end date is required!' }],
  agencyName: [
    { required: true, message: 'Agency name is required!' },
    { max: 255, message: 'Agency name must be at most 255 characters!' },
  ],
  licenseNumber: [
    { required: true, message: 'License number is required!' },
    { max: 100, message: 'License number must be at most 100 characters!' },
  ],
};
